package com.tovtalk.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.tovtalk.ui.adaptive.adaptive
import com.tovtalk.ui.adaptive.rememberScreenWidthDp

@Composable
fun BannerAdRow(
    url: String,
    modifier: Modifier = Modifier,
) {
    val screenWidthDp by rememberScreenWidthDp()
    val navWidth = adaptive(
        compact = 0f, mediumCompact = 0f, medium = 56f,
        expanded = 56f, large = 220f, extraLarge = 220f
    )
    val gridWidth = screenWidthDp - navWidth
    val bannerCount = maxOf(1, (gridWidth / (320f + 12f)).toInt())

    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(vertical = 8.dp),
        horizontalArrangement = Arrangement.Center
    ) {
        repeat(bannerCount) { index ->
            if (index > 0) Spacer(modifier = Modifier.width(12.dp))
            BannerAdView(url = url, modifier = Modifier.width(320.dp).height(50.dp))
        }
    }
}

fun bannerInsertionInterval(gridColumns: Int): Int = gridColumns * 3
